<template>
  <div class="cmp-distribution-reports">
    <div v-show="activeTabIndex !== 0" class="actions">
      <h1>{{ $t('btn_summerized_reports') }}</h1>
      <button class="dt-button v1 s6" @click.stop="back">{{ $t('back_to_report') }}</button>
    </div>
    <MainReport :tabs="tabs" v-show="activeTabIndex == 0" />
    <ng-container v-for="tab of tabs" :key="tab.tabId">
      <div v-if="activeTabIndex == tab.tabId" style="height: 100%">
        <SummarizedReport :reportData="tab.reportData" />
        <button
          v-if="activeTabIndex == tab.tabId"
          style="margin: 15px 25px 0 25px"
          class="dt-button v1 s6"
          @click.stop="onExport(tab)"
        >
          {{ $dft.snakeCaseToWords("export excel") }}
        </button>
      </div>
    </ng-container>
  </div>
</template>


<script>
import MainReport from "./reports-main.vue";
import SummarizedReport from "./report-summarized.vue";
import { ReportService } from "../../services/reports.service";
import app from "../../../../store/app/";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { MainReport, SummarizedReport },
  mounted: function () {},
  data: function () {
    return {
      activeTabIndex: 0,
      tabList: [],
    };
  },
  computed: {
    ...mapGetters(["appNavItems"]),

    tabs: function () {
      let tabs = [];
      console.log("appNavItems", this.appNavItems);
      if (this.appNavItems && this.appNavItems.length > 0) {
        this.appNavItems.forEach((module) => {
          if (module.route == "distribution") {
            module.children.forEach((sub) => {
              if (sub.route == "reports") {
                tabs = [...sub.children];
              }
            });
          }
        });
      }

      return tabs;
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {
        if (to.path.match("summarized")) {
          const param = this.$router.currentRoute.params["tabId"];
          const tab = this.tabs.find((tab) => tab.route == param);
          if (tab) {
            this.tabSelected(tab);
          } else {
            this.activeTabIndex = 0;
          }
        }
        else {
            this.activeTabIndex = 0;
          }
      },
    },
  },
  methods: {
    async onExport(tab) {
      console.log("export");
      const fileURL = await ReportService.exportReportData(tab.token);
      console.log({ fileURL: fileURL });
      location.href = fileURL;
    },
    back() {
      this.activeTabIndex = 0;
      this.$router.push({
        path: `/main/distribution/reports`,
      });
    },

    tabSelected: function (tab) {
      this.activeTabIndex = tab.tabId;
    },
    tabClose(index) {
      this.tabs.splice(index, 1);
      this.activeTabIndex = 0;
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss" >
.cmp-distribution-reports {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 100%;
  background: none;
  .actions {
    h1 {
      font-weight: 600;
    }
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0 42px 0 25px;
  }
  .dt-tab {
    padding-bottom: 10px;
    .tabs__bar .tabs__wrapper .tabs__container,
    .dt-tabs-container {
      border-bottom: 1px solid #7b7a79;
      background: #ccc !important;
      .tabs__div .tabs__item {
        background: #7b7a79;
        color: #fff;
        &.tabs__item--active {
          background: #4d4d4d;
        }
      }
    }
  }
  .tab-close {
    // display: grid;
    // place-content: center;
    // position: absolute;
    // top: -0.1rem;
    // width: 20px;
    // height: 20px;
    // border-radius: 50%;
    // background: white;
    // z-index: 1;
    // margin-left: 13rem;
    img {
      margin: -2px -8px -7px -3px;
      width: 25px;
    }
  }
}
</style>